module.exports = __webpack_public_path__ + "static/media/taraFootballOne.266fa104.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/taraFootballOne.svg
// module id = 613
// module chunks = 0